export enum DataroomStageName {
  NotLive = 'Not Live',
  Live = 'Live',
  InBlackout = 'In Blackout',
  Closed = 'Closed',
}
